(()=>{
if(window.DiversityProfile)return;
const KEYS={
  fit:'dc-my-fit-closet-v1',
  measurements:'dc-fit-body-measurements-v1',
  closet:'dc-closet-twin-v1',
  styleStudio:'dc-style-studio-board-v1',
  tryOn:'dc-try-on-list-v1',
  lastSearch:'dc-last-fashion-search',
  styleQuiz:'dc-style-profile-quiz-v2',
  stylePrefs:'dc-style-preferences-v1'
};
const PROFILE_KEY='dc-unified-profile-v1';
const AESTHETICS=['Minimalism','Elevated Vintage','Modern Romance','Downtown Creative','Statement Sport','Designer Archive'];
const parse=(value,fallback)=>{try{const data=JSON.parse(value);return data==null?fallback:data}catch(e){return fallback}};
const read=(key,fallback)=>parse(localStorage.getItem(key)||'',fallback);
const write=(key,value)=>{try{localStorage.setItem(key,typeof value==='string'?value:JSON.stringify(value));return true}catch(e){return false}};
function ensureQuizDefault(){
  const fit=read(KEYS.fit,{})||{},quiz=read(KEYS.styleQuiz,{})||{},prefs=read(KEYS.stylePrefs,{})||{};
  if(quiz.primary&&!prefs.preferredAesthetic&&!fit.aesthetic){
    fit.aesthetic=quiz.primary;
    write(KEYS.fit,fit);
    write(KEYS.stylePrefs,{preferredAesthetic:quiz.primary,source:'quiz',updatedAt:new Date().toISOString()});
  }
}
const build=()=>{
  const fit=read(KEYS.fit,{})||{},quiz=read(KEYS.styleQuiz,{})||{},prefs=read(KEYS.stylePrefs,{})||{};
  const preferred=prefs.preferredAesthetic||fit.aesthetic||quiz.primary||'';
  return{
    version:2,
    updatedAt:new Date().toISOString(),
    fit,
    measurements:read(KEYS.measurements,{})||{},
    closet:read(KEYS.closet,[])||[],
    styleStudio:read(KEYS.styleStudio,[])||[],
    tryOn:read(KEYS.tryOn,[])||[],
    lastSearch:localStorage.getItem(KEYS.lastSearch)||'',
    styleProfile:{
      quiz,
      preferredAesthetic:preferred,
      preferredSource:prefs.source||(fit.aesthetic?'manual':quiz.primary?'quiz':''),
      secondaryAesthetic:quiz.secondary||'',
      accentAesthetic:quiz.accent||''
    }
  };
};
const save=(profile)=>{try{localStorage.setItem(PROFILE_KEY,JSON.stringify(profile))}catch(e){};document.dispatchEvent(new CustomEvent('dc:profile-updated',{detail:{profile}}));return profile};
const sync=()=>{ensureQuizDefault();return save(build())};
const get=()=>read(PROFILE_KEY,null)||sync();
const set=(area,value)=>{const key=KEYS[area];if(!key)return get();try{if(area==='lastSearch')localStorage.setItem(key,String(value||''));else localStorage.setItem(key,JSON.stringify(value))}catch(e){}return sync()};
const setPreferredAesthetic=(aesthetic,source='manual')=>{
  if(aesthetic&&!AESTHETICS.includes(aesthetic))return get();
  const fit=read(KEYS.fit,{})||{};
  fit.aesthetic=aesthetic||'';
  write(KEYS.fit,fit);
  write(KEYS.stylePrefs,{preferredAesthetic:aesthetic||'',source,updatedAt:new Date().toISOString()});
  return refresh();
};
const setQuizResult=(quiz)=>{
  if(!quiz||!AESTHETICS.includes(quiz.primary))return get();
  const oldQuiz=read(KEYS.styleQuiz,{})||{};
  quiz=Object.assign({},quiz,{
    originalPrimary:oldQuiz.originalPrimary||oldQuiz.primary||quiz.primary,
    originalCompletedAt:oldQuiz.originalCompletedAt||oldQuiz.completedAt||quiz.completedAt
  });
  write(KEYS.styleQuiz,quiz);
  const prefs=read(KEYS.stylePrefs,{})||{},fit=read(KEYS.fit,{})||{};
  const canDefault=!prefs.preferredAesthetic||prefs.source==='quiz'||(!prefs.source&&!fit.aesthetic);
  if(canDefault){
    fit.aesthetic=quiz.primary;
    write(KEYS.fit,fit);
    write(KEYS.stylePrefs,{preferredAesthetic:quiz.primary,source:'quiz',updatedAt:new Date().toISOString()});
  }
  return refresh();
};
const counts=(p=get())=>({closet:Array.isArray(p.closet)?p.closet.length:0,styleStudio:Array.isArray(p.styleStudio)?p.styleStudio.length:0,tryOn:Array.isArray(p.tryOn)?p.tryOn.length:0});
function fill(form,name,value){
  if(!form||value==null||value==='')return;
  const field=form.elements&&form.elements[name];if(!field)return;
  if(field.length&&field[0]&&field[0].type==='radio'){Array.from(field).forEach(x=>x.checked=x.value===String(value));return}
  if(!field.value)field.value=String(value);
}
function hydrate(profile){
  const fit=Object.assign({},profile.fit||{});
  if(profile.styleProfile&&profile.styleProfile.preferredAesthetic)fit.aesthetic=profile.styleProfile.preferredAesthetic;
  const measurements=profile.measurements||{};
  document.querySelectorAll('[data-dc-closet] form').forEach(form=>{
    ['top','bottom','shoe','aesthetic','presentation','category','budget','fit'].forEach(n=>fill(form,n,fit[n]));
    ['chest','waist','hips'].forEach(n=>fill(form,n,measurements[n]));
  });
  document.querySelectorAll('.dc-stable form').forEach(form=>{
    ['top','bottom','shoe','presentation','category','budget'].forEach(n=>fill(form,n,fit[n]));
    if(fit.aesthetic)form.querySelectorAll('input[name="aesthetic"]').forEach(x=>{if(x.value===fit.aesthetic)x.checked=true});
  });
}
function renderStyleCard(profile){
  const sp=profile.styleProfile||{},quiz=sp.quiz||{};
  document.querySelectorAll('[data-dc-style-profile-card]').forEach(card=>{
    const primary=card.querySelector('[data-style-primary]'),secondary=card.querySelector('[data-style-secondary]'),accent=card.querySelector('[data-style-accent]'),select=card.querySelector('[data-style-preferred]'),note=card.querySelector('[data-style-source]');
    if(primary)primary.textContent=sp.preferredAesthetic||quiz.primary||'Not set yet';
    if(secondary)secondary.textContent=quiz.secondary||'Open';
    if(accent)accent.textContent=quiz.accent||'Open';
    if(select&&sp.preferredAesthetic)select.value=sp.preferredAesthetic;
    if(note)note.textContent=quiz.primary?(sp.preferredSource==='manual'?'Quiz result: '+quiz.primary+' · Current preference edited by you':'Based on your Style Profile Quiz · You can change this anytime'):'Take the quiz to create a starting style direction.';
  });
}
function render(profile){
  if(!document.body)return;
  const fit=profile.fit||{},c=counts(profile),summary=[fit.top,fit.bottom,fit.shoe?fit.shoe+' shoe':''].filter(Boolean).join(' · ');
  document.querySelectorAll('[data-dc-fit-summary]').forEach(el=>el.textContent=summary||'Add your fit profile');
  document.querySelectorAll('[data-dc-my-diversity-hub] .dc-os-profile').forEach(box=>{
    let el=box.querySelector('[data-dc-unified-stats]');
    if(!el){el=document.createElement('span');el.className='dc-os-pill';el.setAttribute('data-dc-unified-stats','');box.append(el)}
    const bits=[];if(c.closet)bits.push(c.closet+' closet');if(c.styleStudio)bits.push(c.styleStudio+' outfit');if(c.tryOn)bits.push(c.tryOn+' try-on');
    el.textContent=bits.length?bits.join(' · '):'Profile connected';
  });
  renderStyleCard(profile);
  hydrate(profile);
}
function refresh(){const p=sync();render(p);return p}
window.DiversityProfile={version:2,key:PROFILE_KEY,keys:KEYS,get,sync:refresh,set,setPreferredAesthetic,setQuizResult,counts};
document.addEventListener('DOMContentLoaded',()=>{
  refresh();
  document.addEventListener('change',e=>{
    const aesthetic=e.target.closest('[data-dc-closet] select[name="aesthetic"]');
    if(aesthetic){setPreferredAesthetic(aesthetic.value,'manual');return}
    setTimeout(refresh,20);
  },true);
  document.addEventListener('submit',e=>{
    const form=e.target.closest('[data-dc-style-profile-preference-form]');
    if(form){
      e.preventDefault();
      const value=form.elements.aesthetic.value||'';
      setPreferredAesthetic(value,'manual');
      const status=form.querySelector('[data-style-save-status]');if(status)status.textContent='Preferred aesthetic updated.';
      return;
    }
    setTimeout(refresh,40);
  },true);
  document.addEventListener('click',e=>{if(e.target.closest('[data-save],[data-forget],[data-dc-try-on],[data-twin-clear],[data-style-result-id],[data-clear]'))setTimeout(refresh,80)},true);
  setInterval(refresh,3000);
},{once:true});
window.addEventListener('pageshow',refresh);
})();